import { PayloadAction } from '@reduxjs/toolkit';

import { MockupState } from 'editor/src/store/mockup/types';

const setSelectedSceneIdReducer = (state: MockupState, action: PayloadAction<string>) => {
  state.scenes.selectedSceneId = action.payload;
};

export default setSelectedSceneIdReducer;
